<template>
  <div>
    <v-dialog v-model="show" scrollable persistent max-width="1000px">
      <v-card>
        <v-card-text style="max-height: 600px">
          <div>
            <template v-if="loading">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="35px"
                width="7px"
              ></scale-loader>
            </template>
            <template v-else>
              <v-radio-group v-model="filterType" row @change="onChangeFilterType">
                <v-radio :label="$t('Replying all post(s)')" color="primary" value="all"></v-radio>
                <v-radio
                  :label="$t('Replying selected post(s)')"
                  color="primary"
                  value="includes"
                ></v-radio>
                <v-radio
                  :label="$t('Not replying selected post(s)')"
                  color="primary"
                  value="excludes"
                ></v-radio>
                <v-radio
                  :label="$t('Replying post(s) that has keywords')"
                  color="primary"
                  value="post_keywords"
                ></v-radio>
              </v-radio-group>
              <template v-if="filterType == 'all'">
                <div class="text-xs-center caption py-2">
                  {{ $t('All posts are replied.') }}
                </div>
              </template>
              <template v-else-if="filterType == 'includes'">
                <v-layout>
                  <v-flex class="pt-2 pb-2">
                    {{ $t('Replying selected post(s)') }}
                  </v-flex>
                </v-layout>

                <div style="max-height: 300px; overflow-y: auto">
                  <div v-if="includes.length == 0" class="text-xs-center caption py-2">
                    {{ $t('All posts are replied.') }}
                    {{ $t('Click the button Add Post for more.') }}
                  </div>
                  <template v-for="(post, index) in includes" v-else>
                    <div :key="index" class="z-border-red mb-2 pa-2">
                      <v-layout>
                        <v-flex class="pa-2">
                          <div class="primary--text">{{ post.name }}</div>
                          <div class="caption grey--text">
                            {{ post.id }}
                          </div>
                        </v-flex>
                        <v-flex class="text-xs-right pa-2">
                          <v-btn
                            small
                            fab
                            outline
                            class="ma-0 extra-small"
                            color="primary"
                            @click="onDeleteIncludePost(post)"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </div>

                <div class="text-xs-center">
                  <v-btn
                    outline
                    color="primary"
                    small
                    @click="
                      isShow = true
                      filterType = 'includes'
                    "
                  >
                    <v-icon small>add</v-icon>
                    {{ $t('Add ads post') }}
                  </v-btn>
                  <v-btn depressed color="primary" small @click="showPost = true">
                    <v-icon small>add</v-icon>
                    {{ $t('Add post') }}
                  </v-btn>
                </div>
              </template>

              <template v-else-if="useexclude && filterType == 'excludes'">
                <v-layout>
                  <v-flex class="pt-2 pb-2">
                    {{ $t('Not replying selected post(s)') }}
                  </v-flex>
                </v-layout>

                <div style="max-height: 300px; overflow-y: auto">
                  <div v-if="excludes.length == 0" class="text-xs-center caption py-2">
                    {{ $t('All posts are replied.') }}
                    {{ $t('Click the button Add Post for more.') }}
                  </div>

                  <template v-for="(post, index) in excludes" v-else>
                    <div :key="index" class="z-border-red mb-2 pa-2">
                      <v-layout>
                        <v-flex class="pa-2">
                          <div class="primary--text">{{ post.name }}</div>
                          <div class="caption grey--text">
                            {{ post.id }}
                          </div>
                        </v-flex>
                        <v-flex class="text-xs-right pa-2">
                          <v-btn
                            small
                            fab
                            outline
                            class="ma-0 extra-small"
                            color="primary"
                            @click="onDeleteExcludePost(post)"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>

                  <div class="text-xs-center">
                    <v-btn
                      outline
                      color="primary"
                      small
                      @click="
                        isShow = true
                        filterType = 'excludes'
                      "
                    >
                      <v-icon small>add</v-icon>
                      {{ $t('Add ads post') }}
                    </v-btn>
                    <v-btn depressed color="primary" small @click="showPost = true">
                      <v-icon small>add</v-icon>
                      {{ $t('Add post') }}
                    </v-btn>
                  </div>
                </div>
              </template>

              <template v-else-if="filterType == 'post_keywords'">
                <v-layout>
                  <v-flex class="pt-2 pb-2">
                    {{ $t('Replying post(s) that has keywords') }}
                  </v-flex>
                </v-layout>

                <div
                  xs12
                  class="form-control pa-1"
                  :class="{ 'has-error': errorFilterTag.length > 0 }"
                >
                  <tags
                    v-model="keyword"
                    :tags="keywords"
                    style="margin-bottom: 10px"
                    :btn-text="$t('Add keyword')"
                    :is-drag="false"
                    @tags-changed="addKeywords"
                    @before-adding-tag="checkKeyword"
                  ></tags>

                  <span v-if="errorFilterTag.length > 0" class="text-error">
                    <template v-if="errorFilterTag.includes('overmaxlength')">{{
                      $t('Message cannot be longer than 20 alphabets')
                    }}</template>
                    <template v-else-if="errorFilterTag.includes('duplicate')">{{
                      $t('Duplicate Tag')
                    }}</template>
                  </span>
                </div>

                <div class="red--text">
                  {{ $t('Remark') }} : การตั้งค่าตอบเฉพาะโพสต์ที่มีคีย์เวิร์ด
                  จะทำงานกับทุกโพสต์ที่มีการตั้งค่าในส่วนนี้
                </div>
              </template>

              <v-dialog v-model="isShow" persistent max-width="600">
                <v-card>
                  <v-card-text>
                    <div class="form-control">
                      <input v-model="adsName" type="text" placeholder="Post Name" />
                    </div>

                    <div class="form-control">
                      <input v-model="adsValue" type="text" placeholder="PAGE ID_POST ID" />
                    </div>

                    <div class="text-xs-center">
                      <v-btn depressed color="primary" @click="onAddAdsPost">{{ $t('Add') }}</v-btn>
                      <v-btn
                        outline
                        color="grey"
                        @click="
                          isShow = false
                          adsValue = null
                          adsName = null
                        "
                        >{{ $t('cancel') }}</v-btn
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="cancelPost">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="saveEditPost">
            {{ $t('Select') }}
          </v-btn>

          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPost" scrollable max-width="600px">
      <v-card>
        <div class="form-control px-2 pt-2 pb-1">
          <input v-model="search" type="text" :placeholder="$t('Search')" />
        </div>
        <v-divider></v-divider>
        <v-card-text max-height="600px">
          <v-tabs v-model="tab" color="white" :slider-color="$vuetify.theme.primary" show-arrows>
            <v-tab :key="'published_post'" ripple :href="'#published_post'">{{
              $t('Published post')
            }}</v-tab>

            <v-tab :key="'schedule_post'" ripple :href="'#schedule_post'">{{
              $t('Schedule post')
            }}</v-tab>

            <v-tabs-items touchless>
              <v-tab-item :key="'published_post'" touchless :value="'published_post'">
                <div style="padding: 15px 25px">
                  <template v-if="loading">
                    <scale-loader
                      :color="$vuetify.theme.primary"
                      height="35px"
                      width="7px"
                    ></scale-loader>
                  </template>
                  <template v-else-if="filterPublishedPost.length > 0">
                    <div
                      v-for="(p, index) in filterPublishedPost"
                      :key="'published_post_' + index"
                      class="z-border-red mb-1"
                      style="padding: 10px; position: relative; cursor: pointer"
                    >
                      <v-layout>
                        <v-flex>
                          <div style="padding-left: 10px; word-break: break-all">
                            <a
                              :href="'https://www.facebook.com/' + p.id"
                              target="_blank"
                              rel="noopener noreferrer"
                              :title="p.name"
                              >{{ p.name | truncate(200) }}</a
                            >
                          </div>
                        </v-flex>

                        <v-flex shrink>
                          <v-btn small depressed @click="selectedPost(p)">
                            {{ $t('Select') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>

                    <div class="text-xs-center">
                      <v-btn
                        v-if="hasMorePublishPost"
                        color="primary"
                        outline
                        :loading="loadingPublishedPost"
                        @click="getPublishedPost"
                        >{{ $t('Next') }}</v-btn
                      >
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-xs-center">{{ $t('No post') }}</div>
                  </template>
                </div>
              </v-tab-item>
              <v-tab-item :key="'schedule_post'" touchless :value="'schedule_post'">
                <div style="padding: 15px 25px">
                  <template v-if="loading">
                    <scale-loader
                      :color="$vuetify.theme.primary"
                      height="35px"
                      width="7px"
                    ></scale-loader>
                  </template>
                  <template v-else-if="filterSchedulePost.length > 0">
                    <div
                      v-for="(p, index) in filterSchedulePost"
                      :key="'schedule_post_' + index"
                      class="z-border-red"
                      style="
                        padding: 15px;
                        margin-bottom: 15px;
                        position: relative;
                        cursor: pointer;
                      "
                    >
                      <v-layout>
                        <v-flex>
                          <div style="padding-left: 10px; word-break: break-all">
                            <a
                              :href="'https://www.facebook.com/' + p.id"
                              target="_blank"
                              rel="noopener noreferrer"
                              :title="p.name"
                              >{{ p.name | truncate(200) }}</a
                            >
                          </div>
                        </v-flex>

                        <v-flex shrink>
                          <v-btn small depressed @click="selectedPost(p)">
                            {{ $t('Select') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>

                    <div class="text-xs-center">
                      <v-btn
                        v-if="hasMoreSchedulePost"
                        color="primary"
                        outline
                        :loading="loadingSchedulePost"
                        @click="getSchedulePost"
                        >{{ $t('Next') }}</v-btn
                      >
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-xs-center">{{ $t('No post') }}</div>
                  </template>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import { Promise } from 'q'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Tags from '@/components/elements/Tags'
export default {
  components: {
    ModalDialog,
    ScaleLoader,
    Tags
  },
  props: {
    includePost: {
      default: []
    },
    excludePost: {
      default: []
    },
    post_keywords: {
      default: []
    },
    show: {
      default: false
    },
    singleselect: {
      default: false
    },
    useexclude: {
      default: false
    }
  },
  data: function () {
    return {
      showPost: false,
      publishedPostOption: [],
      schedulePostOption: [],
      posts: '',
      search: '',
      tab: 'published_post',
      loading: false,
      nextPublishPost: null,
      hasMorePublishPost: true,
      nextSchedulePost: null,
      hasMoreSchedulePost: true,
      loadingPublishedPost: true,
      loadingSchedulePost: true,
      isShow: false,
      adsValue: '',
      adsName: '',
      includes: [],
      excludes: [],
      keywords: [],
      filterType: 'all',
      keyword: '',
      errorFilterTag: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterPublishedPost: function () {
      var vm = this

      var includes = this.includes.map((el) => {
        return el.id
      })
      var excludes = this.excludes.map((el) => {
        return el.id
      })
      var posts = this.publishedPostOption.filter((el) => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function (post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    },
    filterSchedulePost: function () {
      var vm = this

      var includes = this.includes.map((el) => {
        return el.id
      })
      var excludes = this.excludes.map((el) => {
        return el.id
      })
      var posts = this.schedulePostOption.filter((el) => {
        return !includes.includes(el.id) && !excludes.includes(el.id)
      })
      if (vm.search !== '') {
        return posts.filter(function (post) {
          return post.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
      return posts
    }
    //  keywords: {
    //   get() {
    //     let vm = this
    //     if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
    //       var tags = []
    //       tags = vm.filter.tags.split(',')
    //       var result = []
    //       if (tags) {
    //         tags.map(function(tag, index) {
    //           result.push({ text: tag })
    //         })
    //       }
    //       return result
    //     } else {
    //       return []
    //     }
    //   },
    //   set(value) {
    //     let vm = this
    //     var result = []
    //     if (value) {
    //       value.map(function(tag, index) {
    //         result.push(tag.text)
    //       })
    //     }
    //     vm.filter.tags = result.join(',')
    //   }
    // }
  },
  mounted: function () {
    var vm = this
    vm.posts = vm.includePost
    var posts = []
    if (this.posts && this.posts != '' && this.posts != null) {
      try {
        posts = JSON.parse(this.posts)
      } catch (error) {
        var tmp_posts = this.posts.split(',')
        posts = tmp_posts.map((el) => {
          return {
            id: el,
            name: el
          }
        })
      }
    }
    vm.includes = posts
    if (posts.length > 0) {
      this.filterType = 'includes'
    } else {
      try {
        vm.excludes = JSON.parse(this.excludePost)
      } catch (error) {
        vm.excludes = []
      }
      if (vm.excludes.length > 0) {
        this.filterType = 'excludes'
      } else {
        try {
          let keywords = JSON.parse(this.post_keywords)
          vm.keywords = keywords.map(function (tag, index) {
            return { text: tag }
          })
        } catch (error) {
          vm.keywords = []
        }
        if (vm.keywords.length > 0) {
          this.filterType = 'post_keywords'
        } else {
          this.filterType = 'all'
        }
      }
    }
    vm.cache_includes = JSON.stringify(vm.includes)
    vm.cache_excludes = JSON.stringify(vm.excludes)
    vm.loading = true
    vm.getPublishedPost().then(
      function () {
        vm.getSchedulePost().then(
          function () {
            vm.loading = false
          },
          function (e) {
            vm.loading = false
          }
        )
      },
      function (e) {
        vm.loading = false
      }
    )
  },
  methods: {
    addKeywords: function (newKeyword) {
      this.keywords = newKeyword
    },
    checkKeyword(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    async onChangeFilterType(val) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to change the reply mode?'),
        text: this.$t('The change may delete your selected posts.'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.filterType = val
        if (val == 'includes') {
          this.excludes = []
          this.keywords = []
        } else if (val == 'exclude') {
          this.includes = []
          this.keywords = []
        } else if (val == 'post_keywords') {
          this.excludes = []
          this.includes = []
        }
      } else {
        if (this.includes.length > 0) {
          this.filterType = 'includes'
        } else if (this.excludes.length > 0) {
          this.filterType = 'excludes'
        } else if (this.keywords.length > 0) {
          this.filterType = 'post_keywords'
        } else {
          this.filterType = 'all'
        }
        // this.filterType = val == 'includes' ? 'excludes' : 'includes'
      }
    },
    clearAllPost: async function () {
      var result = await this.$swal.fire({
        title: this.$t('ต้องการเลือกทุกโพส'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        this.includes = []
        this.excludes = []
        this.saveEditPost()
      }
    },
    getPublishedPost: function () {
      return new Promise((resolve, reject) => {
        var vm = this
        vm.loadingPublishedPost = true

        api.getPublishedPost(vm.nextPublishPost).then(
          function (response) {
            if (response.paging && response.paging.next) {
              vm.nextPublishPost = response.paging.next
            } else {
              vm.hasMorePublishPost = false
            }
            if (response.data) {
              response.data.map(function (post, index) {
                if (post.message || post.story) {
                  vm.publishedPostOption.push({
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                } else {
                  vm.publishedPostOption.push({
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                }
              })
              vm.loadingPublishedPost = false
              resolve()
            }
          },
          function (e) {
            vm.loadingPublishedPost = false
            reject(e)
          }
        )
      })
    },
    getSchedulePost: function () {
      return new Promise((resolve, reject) => {
        var vm = this

        vm.loadingSchedulePost = true
        api.getSchedulePost(vm.nextSchedulePost).then(
          function (response) {
            if (response.paging && response.paging.next) {
              vm.nextSchedulePost = response.paging.next
            } else {
              vm.hasMoreSchedulePost = false
            }
            if (response.data) {
              response.data.map(function (post, index) {
                if (post.message || post.story) {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                } else {
                  vm.schedulePostOption.push({
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  })
                }
              })
              vm.loadingSchedulePost = false
              resolve()
            }
          },
          function (e) {
            vm.loadingSchedulePost = false
            reject(e)
          }
        )
      })
    },
    onDeletePost: function (id) {
      var vm = this
      var index = vm.selectedPosts.findIndex(function (el) {
        return el === id
      })

      if (index != -1) {
        vm.selectedPosts.splice(index, 1)
      }
      vm.$forceUpdate()
    },
    onDeleteIncludePost(post) {
      var vm = this
      var index = vm.includes.findIndex(function (el) {
        return el.id === post.id
      })

      if (index != -1) {
        vm.includes.splice(index, 1)
      }
    },
    onDeleteExcludePost(post) {
      var vm = this
      var index = vm.excludes.findIndex(function (el) {
        return el.id === post.id
      })

      if (index != -1) {
        vm.excludes.splice(index, 1)
      }
    },
    onAddAdsPost: function () {
      if (!this.adsValue && this.adsValue.trim() == '') {
        return false
      }
      var post = {
        id: this.adsValue,
        name: this.adsName && this.adsName.trim() != '' ? this.adsName.trim() : this.adsValue
      }
      if (this.filterType == 'includes') {
        this.includes.push(post)
      } else {
        this.excludes.push(post)
      }
      this.isShow = false
    },
    selectedPublishedPost: function (id) {
      var vm = this
      vm.publishedPostOption.map(function (post, index) {
        if (post.id === id) {
          vm.publishedPostOption[index].selected = !vm.publishedPostOption[index].selected
          return false
        } else if (vm.singleselect) {
          vm.publishedPostOption[index].selected = false
        }
      })

      var index = vm.selectedPosts.findIndex(function (el) {
        return el === id
      })
      if (index == -1) {
        if (vm.singleselect) {
          vm.selectedPosts = id
        } else {
          vm.selectedPosts.push(id)
        }
      } else {
        vm.selectedPosts.splice(index, 1)
      }
    },
    selectedPost: function (post) {
      var vm = this
      var post = {
        id: post.id,
        name: post.name
      }
      if (this.filterType == 'includes') {
        if (this.singleselect) {
          vm.includes = [post]
        } else {
          vm.includes.push(post)
        }
      } else {
        if (this.singleselect) {
          vm.excludes = [post]
        } else {
          vm.excludes.push(post)
        }
      }
      this.showPost = false
    },
    selectedExcludePost: function (post) {
      var vm = this
      var post = {
        id: post.id,
        name: post.name
      }
      if (this.singleselect) {
        vm.excludes = [post]
      } else {
        vm.excludes.push(post)
      }
    },
    saveEditPost: function () {
      var vm = this
      if (this.filterType == 'all') {
        this.includes = []
        this.excludes = []
        this.keywords = []
      } else if (this.filterType == 'includes') {
        this.excludes = []
      } else if (this.filterType == 'excludes') {
        this.includes = []
      }

      let keywords = []

      if (this.filterType == 'post_keywords') {
        keywords = this.keywords.map((el) => {
          return el.text
        })
      }

      vm.$emit('save', {
        includes: JSON.stringify(this.includes),
        excludes: JSON.stringify(this.excludes),
        post_keywords: JSON.stringify(keywords)
      })

      vm.cache_includes = JSON.stringify(vm.includes)
      vm.cache_excludes = JSON.stringify(vm.excludes)
      vm.cache_post_keywords = JSON.stringify(keywords)
      vm.$emit('close')
    },
    cancelPost: function () {
      var vm = this
      vm.includes = JSON.parse(vm.cache_includes)
      vm.excludes = JSON.parse(vm.cache_excludes)

      try {
        let keywords = JSON.parse(vm.cache_post_keywords)
        vm.keywords = keywords.map(function (tag, index) {
          return { text: tag }
        })
      } catch (error) {}
      vm.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSelectPost.vue